export const site = {
  name: 'Rolsys Solutions',
  slogan: 'Innovación en movimiento',
  locale: 'es-MX',
  currency: 'MXN',
  baseUrl: process.env.REACT_APP_SITE_URL || 'http://www.rolsyssolutions.com',
  contact: {
    email:
      process.env.REACT_APP_CONTACT_EMAIL || 'contacto@rolsyssolutions.com',
    phone: '+52 5532861000',
  },
  whatsapp: {
    number: process.env.REACT_APP_WHATSAPP_NUMBER || '+525532861000',
    defaultMessage: 'Hola Rolsys Solutions, me interesa una asesoría en TI.',
    link: 'https://wa.me/message/KR73LSCNYQHVD1',
  },
  address: {
    city: 'Ciudad de México',
    country: 'México',
  },
  social: {
    facebook: '',
    linkedin: '',
    x: '',
  },
  navigation: [
    { label: 'Inicio', path: '/' },
    { label: 'Servicios', path: '/servicios' },
    { label: 'Nosotros', path: '/nosotros' },
    { label: 'Dominios', path: '/dominios' },
    // { label: 'Contacto', path: '/contacto' },
  ],
  categories: [
    {
      title: 'Consultoría Estratégica',
      description: 'Estrategias y planeación para optimizar tu infraestructura tecnológica.',
      icon: 'Lightbulb',
    },
    {
      title: 'Soporte y Mantenimiento TI',
      description: 'Resolución de incidencias y mantenimiento preventivo/correctivo para tus equipos.',
      icon: 'SupportAgent',
    },
    {
      title: 'Presencia Digital y Web',
      description: 'Desarrollo web a la medida y gestión de dominios para destacar en línea.',
      icon: 'Language',
    },
    {
      title: 'Seguridad e Infraestructura',
      description: 'Soluciones integrales de seguridad, venta e instalación de equipos de vigilancia.',
      icon: 'Security',
    }
  ],
  services: [
    {
      title: 'Asesoría en TI',
      slug: 'asesoria-ti',
      category: 'Consultoría Estratégica',
      description:
        'Optimiza tu operación con decisiones tecnológicas informadas.',
      coverage: 'Nacional',
    },
    {
      title: 'Soporte en sitio',
      slug: 'soporte-en-sitio-cdmx',
      category: 'Soporte y Mantenimiento TI',
      description: 'Respuesta rápida en tu ubicación dentro de CDMX.',
      coverage: 'Solo CDMX',
    },
    {
      title: 'Mantenimiento',
      slug: 'mantenimiento-cdmx',
      category: 'Soporte y Mantenimiento TI',
      description: 'Mantenimiento preventivo y correctivo de equipos.',
      coverage: 'Solo CDMX',
    },
    {
      title: 'Soporte remoto',
      slug: 'soporte-remoto-mx',
      category: 'Soporte y Mantenimiento TI',
      description: 'Resolución de incidencias a distancia en todo el país.',
      coverage: 'Nacional',
    },
    {
      title: 'Creación de páginas web',
      slug: 'creacion-paginas-web',
      category: 'Presencia Digital y Web',
      description: 'Diseño y desarrollo web a la medida con UI/UX moderno y optimizado para SEO.',
      coverage: 'Global',
    },
    {
      title: 'Video Vigilancia',
      slug: 'video-vigilancia',
      category: 'Seguridad e Infraestructura',
      description: 'Consultoría, soporte, venta e instalación de sistemas de seguridad.',
      coverage: 'Nacional',
    },
    {
      title: 'Venta de Dominios',
      slug: 'venta-de-dominios',
      category: 'Presencia Digital y Web',
      path: '/dominios',
      description: 'Catálogo de dominios premium, incluye transferencia y opciones de hosting integradas.',
      coverage: 'Global',
    },
  ],
};
